import type { Root } from 'mdast'
import type { TextDirective } from 'mdast-util-directive'
import { visit } from 'unist-util-visit'

/**
 * Remark plugin to disable text directives in terms pages.
 *
 * Since terms pages only use container directives (:::paragraph),
 * we convert any text directives (like :hi) back to plain text
 * to prevent colons in regular text (e.g., "12:00AM") from being
 * misinterpreted as directive syntax.
 *
 * This allows colons in text to be used without escaping.
 */
export function remarkDisableTextDirectives() {
  return (tree: Root) => {
    visit(tree, 'textDirective', (node: TextDirective, index, parent) => {
      if (typeof index === 'number' && parent) {
        parent.children[index] = {
          type: 'text',
          value: `:${node.name}`,
        }
      }
    })
  }
}
